import { FadeSlider } from '../classes/FadeSlider';

document.addEventListener('DOMContentLoaded', () => {
	const sliders = document.querySelectorAll<HTMLElement>('.js-media-text-slider');

	sliders.forEach((root) => {
		const slider = new FadeSlider(root as HTMLElement, {
			autoplay: false,
		});

		const pauseButton = root.querySelector<HTMLButtonElement>('.js-media-text-pause');
		const icon = pauseButton?.querySelector<HTMLElement>('.icn');

		if (!pauseButton || !icon) {
			return;
		}

		const syncUI = (isPaused: boolean) => {
			icon.classList.toggle('icn--play', isPaused);
			icon.classList.toggle('icn--pause', !isPaused);

			pauseButton.setAttribute('aria-pressed', String(isPaused));
			pauseButton.setAttribute('aria-label', isPaused ? 'Autoplay starten' : 'Autoplay pausieren');

			root.classList.toggle('is-paused', isPaused);
		};

		syncUI(true);

		pauseButton.addEventListener('click', (e: MouseEvent) => {
			e.preventDefault();
			if (slider.isPaused) {
				slider.start();
				syncUI(false);
			} else {
				slider.stop();
				syncUI(true);
			}
		});
	});
});
